
<div class="mx-auto p-2 w-full">
    <div class="w-full md:flex lg:flex md:justify-end lg:justify-end md:mb-20">
        <div class="z-10 md:z-0 md:absolute md:w-3/12" *ngIf="filteredSchools.length > 0">
            <div class="bg-gray-50 p-2 rounded-lg shadow-md tour-step-2" (mouseleave)="enableFilter = false">
                <label class="block text-stone-400 text-xs font-normal mb-1">Select School</label>
                <div class="relative">
                    <input type="text" class="block w-full px-3 py-2 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:outline-none"
                    (click)="enableFilter = true" #searchInput [formControl]="searchText"/>
                    <svg class="absolute right-3 top-3 h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 17.5l2.5 2.5" />
                    </svg>
                </div>
                <div class="mt-1" *ngIf="enableFilter">
                    <ul class="bg-white border z-10 md:z-0 border-gray-200 rounded-md shadow-lg max-h-32 overflow-y-auto">
                        <li *ngFor="let school of filteredSchools " [value]="school.id"
                            (click)="selectSchool(school)"
                            class="cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-indigo-500">
                            {{school.name}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Dashboard content goes here -->

    <div class="w-full lg:flex gap-2 pt-2">
        <div class="lg:w-9/12 rounded-lg">
            <div class="w-full lg:flex md:flex">
                <div class=". lg:w-1/2 md:w-1/2 rounded-lg shadow-md p-4 bg-white m-1 tour-step-3">
                    <div class="absolute block text-ls font-bold mb-2 underline text-slate-800" >TN Proficiencies</div>
                    <div class="flex relative justify-end">
                        <span class="rounded-full w-4 h-4 inline-block justify-end" [ngClass]="flags.proficienciFlags > 0 ? 'bg-red-600' : 'bg-green-600'"></span>
                    </div>
                    <div class="mt-2 pt-1">
                        <canvas #tnProficiencyCanvasElement></canvas>
                    </div>
                </div>
                <div class="lg:w-1/2 md:w-1/2 rounded-lg shadow-md p-4 bg-white m-1 tour-step-4">
                    <div class="absolute block text-ls font-bold mb-2 underline text-slate-800">Academic Performance Summary</div>
                    <div class="flex relative justify-end">
                        <span class="rounded-full w-4 h-4 inline-block justify-end" [ngClass]="flags.academics > 0 ? 'bg-red-600' : 'bg-green-600'"></span>
                    </div>
                    <div class="mt-2 pt-1">
                        <canvas #academicCanvasElement></canvas>
                    </div>
                    
                </div>
            </div>
            
        </div>
        <div class="lg:w-3/12 bg-white p-4 rounded-lg shadow-md sm:mt-2 tour-step-5">
            <h2 class="text-ls font-bold mb-2 underline text-slate-800">Flag Notifications</h2>
            <div class="flex p-2 gap-2">
                <span class="rounded-full w-4 h-4 inline-block text-center mt-1" [ngClass]="flags.academics > 0 || flags.proficienciFlags > 0 ? 'bg-red-600' : 'bg-green-600'"></span>
                <div >
                    <span class="block text-blue-500/100 text-sm font-medium underline">ACADEMICS</span>
                    <div class="text-sm">
                        <ul class="list-disc pl-5">
                            <li *ngFor="let flag of academicFlags | keyvalue"
                                [hidden]="flag.value == 'N' || flag.value == null || flag.value == 'no'">
                                {{flag.key}}</li>
                            <li *ngFor="let flag of proficiencyFlags | keyvalue"
                                [hidden]="flag.value == 'N' || flag.value == null || flag.value == 'no'">
                                {{flag.key}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="flex p-2 gap-2">
                <span class="rounded-full w-4 h-4 inline-block text-center mt-1" [ngClass]="flags.ark > 0 ? 'bg-red-600' : 'bg-green-600'"></span>
                <div >
                    <span class="block text-blue-500/100 text-sm font-medium underline">ARK</span>
                    <div class="text-sm  ">
                        <ul class="list-disc pl-5">
                            <li *ngFor="let flag of arkFlags | keyvalue"
                                [hidden]="flag.value == 'N' || flag.value == null || flag.value == 'no'">
                                {{flag.key}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="flex p-2 gap-2">
                <span class="rounded-full w-4 h-4 inline-block text-center mt-1" [ngClass]="flags.enrollment > 0 ? 'bg-red-600' : 'bg-green-600'"></span>
                <div >
                    <span class="block text-blue-500/100 text-sm font-medium underline">ENROLLMENT</span>
                    <div class="text-sm">
                        <ul class="list-disc pl-5">
                            <li *ngFor="let flag of enrollmentFlags | keyvalue"
                                [hidden]="flag.value == 'N' || flag.value == null || flag.value == 'no'">
                                {{flag.key}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full lg:flex gap-2 pt-2">
        <div class="lg:w-9/12 rounded-lg ">
            <div class="w-full lg:flex md:flex">
                <div class="lg:w-1/2 md:w-1/2 rounded-lg shadow-md p-4 bg-white m-1 tour-step-6">
                    <div class="absolute block text-ls font-bold mb-2 underline text-slate-800">ARK Score Breakdown</div>
                    <div class="flex relative justify-end">
                        <span class="rounded-full w-4 h-4 inline-block justify-end" [ngClass]="flags.ark > 0 ? 'bg-red-600' : 'bg-green-600'"></span>
                    </div>
                    <div class="mt-2 pt-1 ">
                        <canvas #arkCanvasElement></canvas>
                    </div>
                </div>
                <div class="lg:w-1/2 md:w-1/2 rounded-lg shadow-md p-4 bg-white m-1 tour-step-7">
                    <div class="absolute block text-ls font-bold mb-2 underline text-slate-800">ENROLLMENT</div>
                    <div class="flex relative justify-end">
                        <span class="rounded-full w-4 h-4 inline-block justify-end" [ngClass]="flags.enrollment > 0 ? 'bg-red-600' : 'bg-green-600'"></span>
                    </div>
                    <div class="mt-2 pt-1">
                        <canvas #enrollmentChart></canvas>
                    </div>
                    <div class="text-center text-sm font-semibold text-slate-600">Avg. Enrollment in K-2 = <span class="px-2 text-black rounded-sm font-bold" [ngClass]="averageEnrollment < 20 ? 'bg-red-500/80' : ''">{{averageEnrollment}}</span></div>
                </div>
            </div>
        </div>
        <div class="lg:w-3/12 bg-white p-4 rounded-lg shadow-md">
            <h2 class=" text-ls font-bold mb-2 underline text-slate-800">Blue Ribbon</h2>
            <div class="flex text-center justify-center">
                <img src="../../assets/blueribbion.png" alt="blueribbion">
            </div>

        </div>
    </div>
</div>